<template>
  <v-layout row wrap mb-0 py-2>
    <case-header-new></case-header-new>
    <v-flex xs12 px-4 mb-0 v-show="hideInbox">
      <v-btn
        class="ml-0 mb-3"
        color="success"
        @click="composeNewEmail()"
      >
        <v-icon class="mr-1">add</v-icon>Compose
      </v-btn>
    </v-flex>

    <v-flex v-show="!showEmailChain" :class="{'mx-0': $vuetify.breakpoint.smAndDown, 'mx-4': $vuetify.breakpoint.mdAndUp}" justify-center align-center>
      <Loading :isLoading="isLoading">
      <ConversationsList
        v-for="(thread, index) in orderedConversations" :key="index"
        :thread="thread"
        :allParticipants="allParticipants"
        v-on:toggle-messages="toggleMessages"
        v-on:detatched-conversation="reloadMessages"></ConversationsList>
      <v-layout v-if="hasMoreConversations && !showEmailChain" justify-center class="mt-3 mb-4">
        <v-btn :loading="isLoadingMore" :disabled="isLoadingMore" color="primary" @click="loadNextConversationsPage">
          Load More Conversations
        </v-btn>
      </v-layout>
      </Loading>
    </v-flex>


  </v-layout>
</template>

<script>
import Vue from 'vue'
import EmailWindow from "@/components/comms/EmailWindow.vue"
import ConversationsList from "@/components/cases/case-edit/conversations/ConversationsList.vue"
import CaseHeaderNew from "@/components/cases/case-edit/CaseHeaderNew.vue"
import Loading from "@/components/shared/Loading.vue"
import Helpers from '@/helpers.js'
import { mapState } from "vuex"

const STATUS_PRIORITY = {
  failed: 4,
  verification_failed: 3,
  sending: 2,
  sent: 1,
  verified: 1,
}

const conversationSort = (a, b) => {
  if (a.messages.length > 0 && b.messages.length > 0) {
    if (a.messages[a.messages.length - 1].createdAt < b.messages[b.messages.length - 1].createdAt) { return -1 }
    if (a.messages[a.messages.length - 1].createdAt > b.messages[b.messages.length - 1].createdAt) { return 1 }
    if (a.messages[a.messages.length - 1].createdAt === b.messages[b.messages.length - 1].createdAt) { return 0 }
  } else {
    if (a.messages.length > 0) { return -1 }
    if (b.messages.length > 0) { return 1 } else { return 0 }
  }
}
export default {
  name: "case-conversations",
  components: { CaseHeaderNew, Loading, ConversationsList, EmailWindow },
  data: () => ({
    hideInbox: true,
    showEmailChain: false,
    currentEmailChain: {},
    composeDialog: false,
    selectedMultipleChipsReply: [],
    availableRecipients: [],
    messageAuthor: {},
    isLoadingMore: false
  }),
  async mounted() {
    this.updatePageTitle()
    await this.reloadMessages()
  },
  computed: {
    ...mapState({
      allUsers: state => (state && state.users && state.users.all) ? state.users.all : [],
      allTeams: state => (state && state.teams && state.teams.all) ? state.teams.all : [],
      currentCase: state => state.cases.currentlySelected.case,
      isLoading: state => state.cases.currentlySelected.loading,
      currentCaseId: state => state.cases.currentlySelected.case && state.cases.currentlySelected.case.id,
      conversationsPagination: state => state.cases.currentlySelected.conversationsPagination,
      user: state => state.currentUser,
      userPreferences: state => state.currentUser.me.preferences
    }),
    hasMoreConversations() {
      return this.conversationsPagination && this.conversationsPagination.hasMore
    },
    title() {
      return (this.currentCase && this.currentCase.title) ? this.currentCase.title : ""
    },
    emailAddresses() {
      const emailFieldNames = []
      if (this.currentCase.schema && this.currentCase.schema.fieldsets) {
        for (const fieldset of this.currentCase.schema.fieldsets) {
          for (const field of fieldset.fields) {
            if (field.type === "email_address") {
              emailFieldNames.push(field.name)
            }
          }
        }
      }
      const emailAddresses = []
      if (emailFieldNames && emailFieldNames.length > 0) {
        for (const emailFieldName of emailFieldNames) {
          const email = this.currentCase.properties[emailFieldName]
          if (email) {
            emailAddresses.push({ displayName: email, type: "Custom", id: 0 })
          }
        }
      }
      const customRecipients = []
      for (const conversation of this.orderedConversations) {
        for (const convMessage of conversation.messages) {
          if (convMessage.from && convMessage.from.type === "Custom") {
            customRecipients.push(convMessage.from)
          }
          for (const recipient of convMessage.recipients) {
            if (recipient.type === "Custom") {
              customRecipients.push(recipient)
            }
          }
        }
      }
      for (const customRecipient of customRecipients) {
        const existingEmailAddress = emailAddresses.find((ee) => ee.displayName === customRecipient.email)
        if (!existingEmailAddress) {
          emailAddresses.push({ displayName: customRecipient.email, email: customRecipient.email, type: "Custom", id: customRecipient.id })
        }
      }
      return emailAddresses
    },
    allParticipants() {
      const participants = []
      let index = 0
      if (this.emailAddresses && this.emailAddresses.length > 0) {
        participants.push({ header: "Email Addresses" })
        participants.push(...this.emailAddresses.map(emailAddress => Object.assign(emailAddress, { index: index++ })))
      }
      participants.push({ header: "Teams" })
      participants.push(...(this.allTeams).map((r) => ({ type: "Team", displayName: r.displayName, id: r.id, index: index++ })))

      participants.push({ header: "Users" })
      participants.push(...(this.allUsers).map((r) => ({ type: "User", displayName: r.displayName, id: r.id, index: index++ })))
      return participants
    },
    orderedConversations() {
      let orderedConversations = []
      if (this.currentCase && this.currentCase.conversations) {
        const convos = this.currentCase.conversations
        orderedConversations = convos.sort(conversationSort)
      }
      return orderedConversations.reverse()
    }
  },
  watch: {
    currentCase: {
      handler(newCase) {
        if (newCase && newCase.caseType && newCase.title) {
          this.updatePageTitle()
        } else {
          this.updatePageTitle()
        }
      },
      immediate: true
    },
    composeMinified: function() {
      document.body.className = this.composeMinified ? "compose-minified" : ""
      document.documentElement.className = this.composeMinified
        ? "scroll-minimise-fix"
        : "scroll-minimise-hidden"
    }
  },
  methods: {
    updatePageTitle() {
      if (this.currentCase && this.currentCase.caseType && this.currentCase.title) {
        this.$store.dispatch("setPageTitle", `${this.currentCase.caseType} - ${this.currentCase.title}`)
      } else {
        this.$store.dispatch("setPageTitle", "Caseblocks")
      }
    },
    composeNewEmail() {
      this.$store.dispatch("composeNewMessage", {currentCase: this.currentCase})
    },
    getMessageAuthor(messages) {
      const message = messages[0]
      this.messageAuthor = this.allUsers.find(user => user.email === message.from.email)
      this.AuthorAvatar = this.messageAuthor
    },
    formatDate(date) {
      if (this.userPreferences.dateTimeFormat) {
        return Helpers.formatDate(date, this.userPreferences.dateTimeFormat)
      } else {
        return Helpers.formatDate(date, 'Do MMM YYYY HH:mm')
      }
    },
    toggleMessages(thread) {
      this.showMessages(thread)
    },
    resolveCaseId() {
      const routeId = this.$route && this.$route.params ? this.$route.params.case_id : null
      if (this.currentCaseId) {
        return this.currentCaseId
      }
      return routeId
    },
    async reloadMessages() {
      const caseId = this.resolveCaseId()
      if (!caseId) {
        return
      }
      await this.$store.dispatch("loadCaseConversationsPage", {
        caseId: caseId,
        page: 1,
        pageSize: 100,
        append: false
      })
    },
    async loadNextConversationsPage() {
      const caseId = this.resolveCaseId()
      if (!caseId || this.isLoadingMore || !this.hasMoreConversations) {
        return
      }
      this.isLoadingMore = true
      try {
        const nextPage = (this.conversationsPagination && this.conversationsPagination.page ? this.conversationsPagination.page : 1) + 1
        await this.$store.dispatch("loadCaseConversationsPage", {
          caseId: caseId,
          page: nextPage,
          pageSize: 100,
          append: true
        })
      } finally {
        this.isLoadingMore = false
      }
    },
    showMessages(thread) {
      thread.messages.forEach(function(msg) {
        msg.isOpen = [false]
        msg.isComposing = false
      })
      this.currentEmailChain = thread
      this.hideInbox = false
      this.showEmailChain = true
      this.getMessageAuthor(thread.messages)
    },
    hideMessages() {
      this.currentEmailChain = {}
      this.hideInbox = true
      this.showEmailChain = false
    },
    async sendNewMessage(message) {
      message.caseId = this.currentCase.id
      await this.$store.dispatch("createCaseConversation", message)
      await this.reloadMessages()
    },
    remove(item) {
      const index = this.selectedMultipleChips.indexOf(item.name)
      if (index >= 0) this.selectedMultipleChips.splice(index, 1)
    },
    deleteComposition: function(msg) {
      document.documentElement.className = document.documentElement.className.replace("scroll-minimise-hidden", "")
      if (msg) { msg.isComposing = false }
      this.message = ""
      this.subject = ""
      this.composeDialog = false
      this.selectedMultipleChips = null
      this.selectedMultipleChipsReply = []
      /* Need to figure out how to clear the recipients select option */
    }
  },
  beforeRouteLeave(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("unsubscribeToCaseChannelV2", { caseId: from.params.case_id, currentUser: currentUser })
    next()
  },
  beforeRouteEnter(to, from, next) {
    const state = Vue.store.state
    const currentUser = Object.assign(state.currentUser.me, { account: { id: state.currentUser.account.id } })
    Vue.store.dispatch("subscribeToCaseChannelV2", { caseId: to.params.case_id, currentUser })
    next()
  }
}
</script>

<style>
.email-row {
  width: calc(100% - 230px);
}

.email-row-mobile {
  width: calc(100% - 30px);
}

.fixed-bar {
  width: 100% !important;
  padding-right: 100px !important;
}

.fixed-bar h4 {
  max-width: 100% !important;
}

.email-row-mobile h4 {
  max-width: calc(100% - 100px) !important;
}

.unread {
  font-weight: 500;
}

.scroll-minimise-fix {
  overflow-y: scroll;
}

.scroll-minimise-hidden {
  overflow-y: hidden;
}

.v-expansion-panel__container.email-conversation .v-avatar.expansion-avatar {
  height: 35px !important;
  width: 35px !important;
}

.v-expansion-panel__container--active.email-conversation
  .v-avatar.expansion-avatar {
  height: 50px !important;
  width: 50px !important;
  margin-top: 12px;
}

.v-expansion-panel__container--active.email-conversation
  .v-avatar.expansion-avatar.status:after {
  left: 0px;
}

.v-expansion-panel__container.email-conversation .recipients {
  display: none;
}

.v-expansion-panel__container--active.email-conversation .recipients {
  display: block;
}

.v-expansion-panel__container.email-conversation .email-right-actions {
  padding: 6px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation .email-right-actions {
  padding: 14px 0 0 0;
}

.v-expansion-panel__container.email-conversation .email-right-actions .v-btn {
  display: none;
}

.v-expansion-panel__container--active.email-conversation
  .email-right-actions
  .v-btn {
  display: inline-block;
}

.v-expansion-panel__container.email-conversation .expansion-avatar .initials {
  font-size: 13px;
  padding: 0px 0 0 0;
}

.v-expansion-panel__container--active.email-conversation
  .expansion-avatar
  .initials {
  font-size: 20px;
  padding: 10px 0 13px 0;
}

.v-expansion-panel__container--active.email-conversation h4 {
  font-size: 26px;
}

.theme--light.v-expansion-panel .v-expansion-panel__container {
  border-top: none;
}
</style>
